import { FC, useEffect, useState } from "react";

import { memberObservable } from "../store/userStore";
import RegistrationForm from "./RegistrationForm";
import { useQuery } from "@tanstack/react-query";
import { nodeServer } from "../constants";
import { ConferenceAttendee, IConference, IConferenceAttendee } from "./conferenceTypes";
import { accessTokenInfo$ } from "../oauth/oauth";
import { Card, CardHeader } from "@fluentui/react-components";
import { useObservable } from "../utility/useObservable";
import { parseLocalDate } from "../utility/DateParse";
// import { useObservable } from "../utility/useObservable";

interface IRegistrationProps {}

const Registration: FC<IRegistrationProps> = () => {
    // const [userState, setUserState] = useState<IMember | null>(
    //     userStore.currentState
    //     // userStore.currentState !== null
    //     //   ? (userStore.currentState as unknown as IMember)
    //     //   : new MemberForm()
    // );

    // const accessToken = useObservable(accessTokenInfo$);
    const userState = useObservable(memberObservable);
    const [registrationFinished, setRegistrationFinished] = useState(false);
    // useLayoutEffect(() => {
    //     userStore.subscribe2(setUserState);
    //     userStore.init();
    // }, []);
    const { data: conference } = useQuery({
        queryKey: ["conferenceRegistration"],
        refetchOnWindowFocus: false,
        enabled: true,
        queryFn: async (signal) => {
            const url = nodeServer + `conference/latest`;
            const res = await fetch(url, { signal: signal.signal });
            if (!res.ok) {
                throw new Error("Network response was not ok");
            }
            const conference: IConference = await res.json();
            console.log(conference);
            if (conference.data.conferenceDetails?.registrationFeeSchedule) {
                for (const item of conference.data.conferenceDetails?.registrationFeeSchedule) {
                    item.deadline = parseLocalDate(item.deadline as unknown as string) || new Date(); // new Date(item.deadline as unknown as string);
                }
            }
            //conference.data.conferenceDetails!.registrationDeadline = new Date(Date.parse(conference.data.conferenceDetails!.registrationDeadline as unknown as string)); // new Date(conference.data.conferenceDetails!.registrationDeadline as unknown as string);
            //conference.data.conferenceDetails!.lateRegistrationDeadline = new Date(conference.data.conferenceDetails!.lateRegistrationDeadline as unknown as string);
            
            const feeSchedule = conference?.data.conferenceDetails?.registrationFeeSchedule;
            const deadlinesSorted = feeSchedule?.sort((a,b)=>a.deadline < b.deadline ? 1 : -1);
            if (deadlinesSorted && deadlinesSorted.length > 0){
                setRegistrationFinished((deadlinesSorted[0].deadline.getTime() + 86400000) < new Date().getTime())

            }
            return conference;
        },
    });

    const getConferenceDues = (conference: IConference, isMember: boolean) => {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let fee = 125;
        for (const feeOption of conference.data.conferenceDetails?.registrationFeeSchedule || []) {
            if (today <= feeOption.deadline) {
                if (feeOption.status === "Members" && isMember) {
                    fee = feeOption.fee;
                    break;
                } else if (feeOption.status === "Non-Members" && !isMember) {
                    fee = feeOption.fee;
                    break;
                } else if (feeOption.status === "All") {
                    fee = feeOption.fee;
                    break;
                } else if ((feeOption.status as string).toLowerCase().includes("non-member") && !isMember) {
                    fee = feeOption.fee;
                    break;
                } else if ((feeOption.status as string).toLowerCase().includes("member") && isMember) {
                    fee = feeOption.fee;
                    break;
                }
            }
        }

        return fee;
    };

    const { data: conferenceAttendee, refetch } = useQuery({
        queryKey: ["conferenceAttendeeRegistration"],
        refetchOnWindowFocus: false,
        enabled: !!conference,
        initialData: undefined,
        queryFn: async (signal) => {
            if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
                const headers = new Headers();
                headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);

                // if (userState !== null) {
                const url = nodeServer + `conference/status`;
                const res = await fetch(url, { headers: headers, method: "get", signal: signal.signal });
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                const json = await res.json();
                if (json.error) {
                    // console.log(json.error);
                }
                if (json.user !== null) {
                    //  console.log("FROM QUERY3");
                    //  console.log(json.user.details);
                    // //json.user.details = JSON.parse(json.user.details);
                    // console.log(json.user);
                    // console.log(conference);
                    return json.user as IConferenceAttendee;
                } else {
                    let attendee: IConferenceAttendee = new ConferenceAttendee();
                    if (userState) {
                        attendee = ConferenceAttendee.fromIMemberInfo(userState);
                    }
                    ConferenceAttendee.setupDetails(attendee, conference!.data);
                    attendee.due = getConferenceDues(conference!, userState !== null && userState !== undefined);
                    // if (conference!.data.conferenceDetails?.registrationDeadline) {
                    //     if (new Date() <= conference!.data.conferenceDetails?.registrationDeadline){
                    //         attendee.due = conference!.data.conferenceDetails?.registrationFee;
                    //     } else {
                    //         attendee.due = conference!.data.conferenceDetails?.lateRegistrationFee;
                    //     }
                    // }
                    console.log("FROM QUERY2");
                    console.log(attendee);

                    return attendee;
                }
            } else {
                let attendee: IConferenceAttendee = new ConferenceAttendee();
                if (userState) {
                    attendee = ConferenceAttendee.fromIMemberInfo(userState);
                }
                ConferenceAttendee.setupDetails(attendee, conference!.data);
                attendee.due = getConferenceDues(conference!, userState !== null && userState !== undefined);

                // if (conference!.data.conferenceDetails?.registrationDeadline) {
                //     if (new Date() <= conference!.data.conferenceDetails?.registrationDeadline){
                //         attendee.due = conference!.data.conferenceDetails?.registrationFee;
                //     } else {
                //         attendee.due = conference!.data.conferenceDetails?.lateRegistrationFee;
                //     }
                // }
                console.log("FROM QUERY");
                console.log(attendee);
                return attendee;
            }
            //}
        },
    });

    useEffect(() => {
        console.log("refetch");
        refetch();
        //queryClient.refetchQueries({queryKey: ["conferenceAttendee"]});
    }, [userState]);

    useEffect(() =>{
        
        

    },[conference])

    useEffect(() => {
        //if (userState !== null) {

        if (userState && conferenceAttendee && conferenceAttendee.updateFromIMemberInfo) conferenceAttendee.updateFromIMemberInfo(userState);
        console.log("maybe update attendee");
        console.log(conferenceAttendee);
        //}
    }, [userState, conferenceAttendee]);

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                <h2>Conference Registration</h2>
                <div>
                    <br />

                    <div>
                        {conferenceAttendee && conferenceAttendee.id !== undefined ? (
                            <Card>
                                <CardHeader style={{ marginTop: -10 }} header={<h3>Registration Fee</h3>} />
                                You've already registered for the conference. If you need to make changes, update your form below. If you need to cancel, please contact us.
                            </Card>
                        ) : (
                            <>
                                <Card>
                                    <CardHeader style={{ marginTop: -10 }} header={<h3>Registration</h3>} />
                                    {registrationFinished ? "Registration for the conference is now closed. If you have any questions, please contact us." : 
                                    "Fill out the form below to register for the conference. If you are a member, you should login so your registration is editable from your account later. "}
                                </Card>
                            </>
                        )}
                    </div>
                    <br />

                    {conferenceAttendee !== undefined && conferenceAttendee !== null && conference && !registrationFinished && <RegistrationForm conference={conference} attendee={conferenceAttendee} readonly={false} />}
                </div>
            </div>
        </div>
    );
};

export default Registration;
